var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateCellBoth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 000 000 L 400 000 L 000 400 z",
    fill: "#6D8BB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 000 400 L 400 000 L 400 400 z",
    fill: "#7DCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCellBoth);
export default __webpack_public_path__ + "static/media/date_cell_both.be3de223c5eb2cc54d3e4f91a6a1fe11.svg";
export { ForwardRef as ReactComponent };